/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Optional } from '@angular/core';
import { IIceEntity } from '../models/core/IceEntity';

import { IcepanelcontainerSettings, IcemattableSettings, IcepanelgroupSettings, IcepanelsectionSettings, IcepanelSettings, IcepanelcontainerRowSettings, IcecontrolPermission, iceColumnDefinition, IcecontrolSettings, IceResponsiveMattableSettings } from '../components/models/icesettings';
import { MatTableDataSource } from '@angular/material';
import { BaseAppService } from '../services/baseapp.service';
import { LoginService } from '../login/login.service';
import { IceNavService } from './ice-nav/ice-nav.service';
import { Router } from '@angular/router';
import { userTypes } from '../login/login.config';
import { Iceutility } from '../services/iceutility';
import { IcepanelService } from './icepanel/icepanel.service';

export interface IBaseView {
  viewSetup(dat: IIceEntity): IcepanelcontainerSettings;
}

export interface IBaseListView {
  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES): IcepanelcontainerSettings;
}

export class BaseListView implements IBaseListView {
  dataAry: IIceEntity[] = null;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([])
  nameOfView: string = "";
  loading = false;
  dataViewSettings: IcepanelcontainerSettings = null;
  tables: IcemattableSettings[];
  private addButton: boolean = true;
  private inLineEditing: boolean = false;

  constructor(private appSvc: BaseAppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private router: Router,
    @Optional() private panelSvc?: IcepanelService) {
  }

  getAppService(): BaseAppService {
    return this.appSvc;
  }

  getNavService(): IceNavService {
    return this.navSvc;
  }

  getRouter(): Router {
    return this.router;
  }

  getEditingSectionTag(): string {
    return this.nameOfView + "EditViewSection";
  }

  getDataSource(): MatTableDataSource<any> {
    return this.dataSource;
  }

  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;

    try {
      if (dat == null) {
        return null;
      }

      this.dataAry = dat;
      this.dataSource.data = this.onGetData(this.dataAry);

      //////////////////////
      // Tables
      this.tables = [
        new IceResponsiveMattableSettings(
          this.nameOfView + "Table",
          this.onGetColumnDefinition(),
          this.dataSource,
          this.onGetActionItems(),
          this.isRowSelectionEnabled(),
          null,
          this.inLineEditing,
          null,
          false,
          false
        ).showAddButton(this.addButton)
      ];
      let apptGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, this.tables, this.getPermission(feature))
      ];

      let apptSections: IcepanelsectionSettings[] = []

      let idControls = this.onGetEditingControls();
      if (this.inLineEditing) {
        apptSections.push(this.appSvc.viewEditPanelSection(this.getEditingSectionTag(), idControls));
      }
      apptSections.push(new IcepanelsectionSettings(this.nameOfView + "ViewSection", { class: [""], styles: { width: "100%" } }, apptGroups, [], null, this.getPermission(feature)));

      let panels: IcepanelSettings[] = [
        new IcepanelSettings(this.nameOfView + "View", "", this.nameOfView, "", apptSections, null, this.getPermission(feature)),
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings(this.nameOfView + "ViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  getPermission(feature): IcecontrolPermission {
    if (!Iceutility.isdefined(feature)) {
      feature = userTypes.USER_FEATURES.ufNone;
    }

    let userInfo = this.loginSvc.GetSessionUserInfo(),
      feaAccess: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;

    feaAccess = this.loginSvc.getFeatureAccess(userInfo, this.appSvc.getCurrentAccount(), feature);
    return new IcecontrolPermission(feature, feaAccess);
  }

  isRowSelectionEnabled(): boolean {
    return false;
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [];
  }

  onGetActionItems(): any[] {
    return [];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  onGetEditingControls(): IcecontrolSettings[] {
    return [];
  }

  enableTableSecondRow(tablIndex: number, enable: boolean) {
    if (this.tables && this.tables.length > 0 && tablIndex >= 0 && tablIndex < this.tables.length) {
      this.tables[tablIndex].enableSecondRow(enable);
    }
  }

  refreshTableData(rows, resetSort: boolean = false): void {
    if (this.tables && this.tables.length > 0) {
      this.tables[0].setLoading(false);
      this.tables[0].iRows.data = this.onGetData(rows);
      if (this.panelSvc != null && this.panelSvc.matSortChangeSubject != null)
        this.panelSvc.matSortChangeSubject.next(resetSort ? "reset" : "keep");
    }
  }

  getTableData(): any[] {
    let data: any[] = [];
    if (this.tables && this.tables.length > 0) {
      data = this.tables[0].iRows.data;
    }
    return data;
  }

  setInlineEditing(val: boolean): void {
    this.inLineEditing = val;
  }

  getInlineEditing(): boolean {
    return this.inLineEditing;
  }

  setAddButton(val: boolean): void {
    this.addButton = val;
  }

  getAddButton(): boolean {
    return this.addButton;
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    this.appSvc.onDefaultToolbarMenuItemOpen(event);
  }
  onToolbarMenuItemClick(event) {
    this.appSvc.onDefaultToolbarMenuItemClick(event, this.router);
  }
}
